import styled from 'styled-components';
import Button from '../button/Button';
import Disclaimer from '../disclaimer/Disclaimer';
import StatusIndicator from '../status-indicator/StatusIndicator';
export const LoanContainer = styled.div `
  position: relative;

  display: flex;
  flex-direction: column;

  width: 100%;

  margin-top: 2.7rem;

  border: 1px solid ${({ theme }) => theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};

  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};

  ${({ theme }) => theme.media.tablet `
    padding-left: 1.5rem;
    padding-right: 2.7rem;
  `};
`;
export const CustomMarginState = styled(StatusIndicator) `
  top: -3.7rem;
  left: -0.8px;

  z-index: ${({ theme }) => theme.zIndex.low};

  &:after {
    height: 46.5px;
    top: -1.1px;
    right: -6.7px;
  }

  ${({ theme }) => theme.media.tablet `
      top: -2.7rem;
      left: -0.8px;
      
      padding:1rem 0 0 1rem;

      
       
      &:after {
        height: 3.5rem;
        top: -0.5px;
        right: -4px;
      }
  `};

  ${({ theme }) => theme.media.laptop `
      &:hover {
        z-index: 2;
      }
  `}
`;
export const LoanBody = styled.div `
  display: flex;
  flex-direction: column;
  padding: 2.9rem 0 2rem;

  z-index: 1;

  ${({ theme }) => theme.media.tablet `
    flex-direction: row;
    

    padding: 2.2rem 0;
  `};
`;
export const CustomInfoContainer = styled.div `
  display: flex;
  flex-direction: row;

  padding: 0 1.3rem 1.5rem;

  ${({ theme }) => theme.media.tablet `
    align-items: center;
    
    width: calc(2 * (100% - 2px) / 3);

    padding: 0;
  `};
`;
export const StatusContainer = styled.div `
  display: flex;
  flex-direction: column;
  width: 50%;

  padding: 1.7rem;

  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.surface.default};

  &:first-child {
    margin-right: 1.4rem;
  }

  ${({ theme }) => theme.media.tablet `
    align-items: center;
    flex-direction: row;

    padding:0;
    margin: 0;

    background-color: transparent;

    &:nth-child(3){
      padding-left: 5%;
    }
  `};
`;
export const StatusIconContainer = styled.div `
  display: flex;

  margin-right: 0;

  ${({ theme }) => theme.media.tablet `
      margin-right: 2rem;
    `}
`;
export const StatusTextContainer = styled.div `
  display: flex;
  flex-direction: column;

  margin-top: 2.1rem;

  z-index: 1;
  ${({ theme }) => theme.media.tablet `
      margin-top: 0;
    `}
`;
export const Line = styled.div `
  display: none;

  width: 1px;
  height: 8rem;

  background-color: ${({ theme }) => theme.colors.borders.default};

  ${({ theme }) => theme.media.tablet `
      display:flex;
    `}
`;
export const MobileDisclaimer = styled(Disclaimer) `
  width: initial;

  margin: 0 1.3rem 1.4rem;

  ${({ theme }) => theme.media.tablet `
      display: none;
    `};
`;
export const ButtonContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  padding: 1.5rem 1.3rem 0;

  border-top: 1px solid ${({ theme }) => theme.colors.borders.default};

  width: 100%;

  ${({ theme }) => theme.media.tablet `
    width: calc((100% - 2px) / 3);

    padding: 0;
    padding-left: 2rem;

    border-top: none;

  `};
`;
export const CustomBtn = styled(Button) `
  max-width: 18rem;
  width: 100%;

  margin-right: 0.7rem;

  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
`;
export const DetailsButton = styled(Button) `
  max-width: 18rem;
  width: 100%;

  margin-left: 0.7rem;

  border: 1px solid ${({ theme }) => theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};

  background-color: ${({ theme }) => theme.colors.surface.default};
`;
export const CustomDisclaimer = styled(Disclaimer) `
  display: none;

  margin-bottom: 1.7rem;

  ${({ theme }) => theme.media.tablet `
      display: flex;
    `};
`;
//# sourceMappingURL=styles.js.map